import React from "react";
import "./json-cell-renderer.scss";

export interface GeneratedCellRendererProps {
  /** what the model generates the column with: "gouid.32", "queryvar.useruid", ... */
  expression: string;
  /** given, the cell offers "generate", which hands a value here (a uid for gouid.N) */
  onGenerate?: () => void;
}

/**
 * An empty cell of a new row that the model generates on insert: says so, so the
 * cell does not look like a missing required value, and for a uid offers to fill one
 * in now. The value can still be typed instead
 * (FEATURE-20261013-generated-uid-on-insert-from-the-model).
 */
export const GeneratedCellRenderer: React.FC<GeneratedCellRendererProps> = ({ expression, onGenerate }) => (
  <span className="json-cell-renderer" title={`Generated on save (${expression}) when left empty`}>
    <span className="json-cell-empty" style={{ fontStyle: "italic", color: "#9ca3af" }}>
      generated on save
    </span>
    {onGenerate && (
      <>
        {" · "}
        <span
          className="json-preview-link"
          style={{ display: "inline", width: "auto" }}
          onClick={(e) => {
            e.stopPropagation();
            onGenerate();
          }}
          onDoubleClick={(e) => e.stopPropagation()}
        >
          generate
        </span>
      </>
    )}
  </span>
);
